// What each template calls a payment (template_type -> noun)
export const templatePaymentWords = {
  realestate: "payment",
  tickets: "purchase",
  fundraiser: "contribution",
  business: "payment",
  donations: "donation",
  chamas: "contribution",
  events: "contribution",
  wedding: "contribution",
  tripsandtravel: "payment",
  funeral: "contribution",
  grouppayments: "payment",
  default: "contribution",
  schools: "payment",
  welfare: "contribution",
  medical: "contribution",
  auctions: "payment",
  paymentforms: "payment",
  church: "giving",
  students: "contribution",
};

const verbs = {
  payment: "Pay",
  purchase: "Purchase",
  contribution: "Contribute",
  donation: "Donate",
  giving: "Give",
};

// Button/label verb for a template, e.g. "chamas" -> "Contribute"
export const getTemplateActionWord = (templateType) =>
  verbs[templatePaymentWords[templateType] || templatePaymentWords.default];

// What each template calls a pledge (template_type -> noun). Templates not
// listed fall back to "pledge".
export const templatePledgeWords = {
  chamas: "contribution due",
  welfare: "contribution due",
  fundraiser: "pledge",
  events: "payment due",
  estate: "payment due",
  auctions: "payment due",
  business: "payment due",
  schools: "payment due",
  default: "pledge",
};

// Word to use instead of "pledge", e.g. "chamas" -> "contribution due"
export const getTemplatePledgeWord = (templateType) =>
  templatePledgeWords[templateType] || templatePledgeWords.default;

// Survey/form names that mark a registration form (e.g. "Registration",
// "Reg.", "New Member Reg", "Membership", "Sign-up", "Join"). "reg" and "join"
// only count as whole words, so "Regular contributions" or "Joint account"
// don't match.
export const isRegistrationSurveyName = (name) =>
  /register|registration|\breg\b\.?|new\s*member|membership|sign[\s-]?up|\bjoin\b/i.test(
    name || ""
  );

